import { BasicCommand, EnvGlobalsHandler } from "@goodgamestudios/core";
import { BasicController } from "@goodgamestudios/core";
import { BasicStandardOkDialogProperties } from "@goodgamestudios/core";

import { ErrorCodes } from "../../constants/shared/ErrorCodes";
import { Poker2Model } from "../../model/Poker2Model";
import { Poker2NoMoneyDialogProperties } from "../../view/dialogs/Poker2NoMoneyDialogProperties";

export class Poker2Command extends BasicCommand {
    /**
     * override the methode to specify the commandhandling
     * use super.executeCommand() to check errorcode 1 and 4
     */
    public executeCommand(error: number, params: any[]): boolean {
        switch (error) {
            case 0:
                break;
            case 10:
                this.layoutManager.showDialog("Poker2NoMoneyDialog", new Poker2NoMoneyDialogProperties(Poker2Model.languageData.getTextById("generic_alert_information"), Poker2Model.languageData.getTextById("alert_not_enough_chips"), 10));
                break;
            case 11:
                this.layoutManager.showDialog("Poker2NoMoneyDialog", new Poker2NoMoneyDialogProperties(Poker2Model.languageData.getTextById("generic_alert_information"), Poker2Model.languageData.getTextById("alert_not_enough_gold"), 11));
                break;
            default:
                this.layoutManager.showDialog("Poker2WarningDialog", new BasicStandardOkDialogProperties(Poker2Model.languageData.getTextById("generic_alert_information"), Poker2Model.languageData.getTextById("errorcode_" + error)));
        }

        return (error == 0);
    }

    protected get env(): Poker2EnvironmentGlobals {
        return <Poker2EnvironmentGlobals>EnvGlobalsHandler.globals;
    }

    protected get controller(): BasicController {
        return BasicController.getInstance();
    }

    protected get layoutManager(): Poker2LayoutManager {
        return Poker2LayoutManager.getInstance();
    }
}

import { Poker2EnvironmentGlobals } from '../../Poker2EnvironmentGlobals';
import { Poker2NoMoneyDialog } from "../../view/dialogs/Poker2NoMoneyDialog";
import { Poker2WarningDialog } from "../../view/dialogs/Poker2WarningDialog";
import { Poker2LayoutManager } from "../../view/Poker2LayoutManager";
